(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    

const mlCarousels = new Map();
function initializeMlCarousels(root) {
  root.querySelectorAll('[data-ml-auto-carousel]').forEach(function(container) {
    if (mlCarousels.has(container)) return;
    const slider = container.querySelector('slider-component');
    const track = slider && slider.querySelector('ul[id^="Slider-"]');
    const next = slider && slider.querySelector('button[name="next"]');
    const toggle = container.querySelector('.ml-carousel-toggle');
    if (!track || !next || !toggle) return;
    let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let hovered = false;
    let focused = false;
    let visible = true;
    function updateToggle() {
      toggle.textContent = paused ? container.dataset.playLabel : container.dataset.pauseLabel;
      toggle.setAttribute('aria-pressed', String(paused));
    }
    updateToggle();
    container.addEventListener('mouseenter', function() { hovered = true; });
    container.addEventListener('mouseleave', function() { hovered = false; });
    container.addEventListener('focusin', function(event) { focused = event.target !== toggle; });
    container.addEventListener('focusout', function(event) {
      focused = container.contains(event.relatedTarget) && event.relatedTarget !== toggle;
    });
    toggle.addEventListener('click', function() { paused = !paused; updateToggle(); });
    const observer = new IntersectionObserver(function(entries) { visible = entries[0].isIntersecting; }, { threshold: 0.15 });
    observer.observe(container);
    const timer = window.setInterval(function() {
      if (paused || hovered || focused || !visible || document.hidden || track.scrollWidth <= track.clientWidth + 2) return;
      if (next.disabled || track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        next.click();
      }
    }, Number(container.dataset.interval) || 6000);
    mlCarousels.set(container, function() { window.clearInterval(timer); observer.disconnect(); });
  });
}
initializeMlCarousels(document);
document.addEventListener('shopify:section:load', function(event) { initializeMlCarousels(event.target); });
document.addEventListener('shopify:section:unload', function(event) {
  event.target.querySelectorAll('[data-ml-auto-carousel]').forEach(function(container) {
    const dispose = mlCarousels.get(container);
    if (dispose) { dispose(); mlCarousels.delete(container); }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlteez-community"] && !Shopify.designMode) return;
  try {
    
(function () {
  var phone = window.matchMedia('(max-width: 749px)');
  function updateDirectory() {
    document.querySelectorAll('.ml-directory-toggle').forEach(function (list) {
      list.open = !phone.matches;
    });
  }
  updateDirectory();
  phone.addEventListener('change', updateDirectory);
  document.addEventListener('shopify:section:load', updateDirectory);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlteez-home"] && !Shopify.designMode) return;
  try {
    
function setBuilderPlaybackSpeed(root) {
  root.querySelectorAll('.ml-builder-video').forEach(function(video) {
    video.defaultPlaybackRate = 2;
    video.playbackRate = 2;
    video.addEventListener('loadedmetadata', function() {
      video.playbackRate = 2;
    }, { once: true });
  });
}
setBuilderPlaybackSpeed(document);
document.addEventListener('shopify:section:load', function(event) {
  setBuilderPlaybackSpeed(event.target);
});

  } catch(e) { console.error(e); }
})();
})();
